import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import classnames from 'classnames'
import { adminAddNotice, adminGetNotice } from '../../redux/action/adminAction'
import AdminHomeHelper from '../../Components/AdminHomeHelper'
const AdminAddNotice = () => {
    const store = useSelector((store) => store)
    const dispatch = useDispatch()
    const history = useHistory()
    const [notice, setNotice] = useState('')
    const [error, setError] = useState({})
    const [isLoading, setIsLoading] = useState(false)
    const [noticeImg, setNoticeImg] = useState('')
    const imagehandler = (e) => {
        if (e.target.files && e.target.files[0]) {
            let img = e.target.files[0]
            setNoticeImg(img)
            console.log(img)
        }
        console.log(noticeImg)
    }


    useEffect(() => {
        if (store.error) {
            setError(store.error)
        }
    }, [store.error])
    const formHandler = (e) => {
        e.preventDefault()
        setIsLoading(true)
        const formData = new FormData();
        formData.append("notice", notice);
        formData.append("noticeImg", noticeImg);
        try {
            dispatch(adminAddNotice(formData));
        } catch (error) {
            console.error('Error:', error);
        }
        console.log(formData)
        setTimeout(() => {
            setIsLoading(false);
        }, 3000);
    }


    useEffect(() => {
        if (store.admin.adminAddNoticeFlag) {
            setError({})
        }
    }, [store.admin.adminAddNoticeFlag])
    useEffect(() => {
        dispatch(adminGetNotice())
    }, [])
    return (
        <div>
            {store.admin.isAuthenticated ? <>
                <div className="container-fluid p-0">
                    <div className="d-flex">
                        <div className="print-helper">
                            <AdminHomeHelper />
                        </div>
                        <div className="mx-1 w-100 ">
                            <div className='px-3 py-1 bg-light d-flex align-items-center justify-content-between'>
                                <h3> <img src="/logo192.png" width={'50px'} alt="" /> ADD NOTICE</h3>
                                <button onClick={() => window.print()} type="button" className=" btn-success btn text-light"> <img src="/image/print.svg" lt="" /> Download</button>
                            </div>
                            <div className="row">
                                <div className="d-flex justify-content-center col-md-6">
                                    <form noValidate onSubmit={formHandler} className="needs-validation">
                                        <div className="form-group">
                                            <label htmlFor="noticeInput">Important News</label>
                                            <textarea
                                                onChange={(e) => setNotice(e.target.value)}
                                                className={`form-control ${error.subjectName ? 'is-invalid' : ''}`}
                                                id="noticeInput"
                                                rows="8"
                                                placeholder="Enter important 📢 Notice here"
                                                required
                                            ></textarea>
                                            {error.subjectName && (
                                                <div className="invalid-feedback">{error.subjectName}</div>
                                            )}
                                        </div>

                                        <div className="form-group">
                                            <label htmlFor="dateInput">Date</label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                id="dateInput"
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="imageInput">Upload Image</label>
                                            <input
                                                type="file"
                                                accept="image/*"
                                                className="form-control-file"
                                                id="imageInput"
                                                onChange={imagehandler}
                                            />
                                        </div>

                                        <div className="row justify-content-center">
                                            <div className="col-md-1">
                                                {isLoading && (
                                                    <div className="spinner-border text-primary" role="status">
                                                        <span className="sr-only">Loading...</span>
                                                    </div>
                                                )}
                                            </div>
                                        </div>

                                        <div className="row justify-content-center">
                                            <div className="col-md-12 text-center">
                                                <button type="submit" className="btn btn-info w-100">
                                                    <img src="/image/add.svg" alt="" /> Push
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <div className=" col-md-6">
                                    <div className="row mainNB my-3 container">
                                        <div className="col-md-12 AdminNBorad  w-100 m-auto">
                                            <h2 className='text-light text-center mt-3'>Notice Board</h2>
                                            <div className="row m-3">
                                                {store.admin.notices.map(notice => (
                                                    <div key={notice._id}>
                                                        <p>{notice.notice}</p>
                                                        <img src={notice.noticeImg} className='img-fluid' alt="" />
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>
                </div></> : (history.push('/'))}
        </div>
    )
}

export default AdminAddNotice
